module.exports = __webpack_public_path__ + "static/media/20.9e99b092.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/20.png
// module id = 523
// module chunks = 0